import type { AnimationsConfig } from "../declarations/config.d.ts";

export const animationsConfig: AnimationsConfig[] = [
  {
    name: "borik",
    coordinates: {
      x: "2588",
      y: "180",
    },
    width: "500",
    hitbox: {
      coordinates: {
        x: "180",
        y: "150",
      },
      width: "270",
      height: "200",
    },
    layer: 3,
    order: 4,
  },
  {
    name: "cernobil",
    coordinates: {
      x: "3453",
      y: "478",
    },
    width: "300",
    hitbox: {
      coordinates: {
        x: "70",
        y: "0",
      },
      width: "200",
      height: "350",
    },
    layer: 3,
    order: 19,
  },
  {
    name: "dira",
    coordinates: {
      x: "2955",
      y: "-89",
    },
    width: "400",
    hitbox: {
      coordinates: {
        x: "50",
        y: "200",
      },
      width: "200",
      height: "200",
    },
    layer: 3,
    order: 23,
  },
  {
    name: "duhacek",
    coordinates: {
      x: "2",
      y: "42",
    },
    width: "500",
    hitbox: {
      coordinates: {
        x: "100",
        y: "50",
      },
      width: "330",
      height: "300",
    },
    layer: 3,
    order: 8,
  },
  {
    name: "ententyk",
    coordinates: {
      x: "1116",
      y: "279",
    },
    width: "800",
    hitbox: {
      coordinates: {
        x: "100",
        y: "250",
      },
      width: "200",
      height: "250",
    },
    layer: 5,
    order: 18,
  },
  {
    name: "hulk",
    coordinates: {
      x: "3109",
      y: "463",
    },
    width: "400",
    hitbox: {
      coordinates: {
        x: "100",
        y: "130",
      },
      width: "150",
      height: "150",
    },
    layer: 3,
    order: 21,
  },
  {
    name: "kacka",
    coordinates: {
      x: "954",
      y: "251",
    },
    width: "700",
    hitbox: {
      coordinates: {
        x: "50",
        y: "50",
      },
      width: "300",
      height: "400",
    },
    layer: 3,
    order: 3,
  },
  {
    name: "kapela",
    coordinates: {
      x: "2284",
      y: "332",
    },
    width: "600",
    hitbox: {
      coordinates: {
        x: "100",
        y: "100",
      },
      width: "400",
      height: "400",
    },
    layer: 3,
    order: 7,
  },
  {
    name: "kostroun",
    coordinates: {
      x: "470",
      y: "734",
    },
    width: "400",
    hitbox: {
      coordinates: {
        x: "0",
        y: "100",
      },
      width: "300",
      height: "300",
    },
    layer: 7,
    order: 16,
  },
  {
    name: "lednice",
    coordinates: {
      x: "-87",
      y: "589",
    },
    width: "500",
    hitbox: {
      coordinates: {
        x: "100",
        y: "100",
      },
      width: "350",
      height: "450",
    },
    layer: 3,
    order: 1,
  },
  {
    name: "mikulas",
    coordinates: {
      x: "1721",
      y: "336",
    },
    width: "500",
    hitbox: {
      coordinates: {
        x: "100",
        y: "50",
      },
      width: "320",
      height: "400",
    },
    layer: 5,
    order: 11,
  },
  {
    name: "mimozemstan",
    coordinates: {
      x: "3249",
      y: "-58",
    },
    width: "600",
    hitbox: {
      coordinates: {
        x: "100",
        y: "50",
      },
      width: "300",
      height: "250",
    },
    layer: 3,
    order: 2,
  },
  {
    name: "opice",
    coordinates: {
      x: "1682",
      y: "-366",
    },
    width: "1200",
    hitbox: {
      coordinates: {
        x: "700",
        y: "500",
      },
      width: "300",
      height: "300",
    },
    layer: 3,
    order: 15,
  },
  {
    name: "ovce",
    coordinates: {
      x: "1765",
      y: "740",
    },
    width: "600",
    hitbox: {
      coordinates: {
        x: "0",
        y: "100",
      },
      width: "300",
      height: "250",
    },
    layer: 3,
    order: 9,
  },
  {
    name: "ozdoby",
    coordinates: {
      x: "1272",
      y: "102",
    },
    width: "650",
    hitbox: {
      coordinates: {
        x: "0",
        y: "700",
      },
      width: "300",
      height: "250",
    },
    layer: 7,
    order: 5,
  },
  {
    name: "pastyri",
    coordinates: {
      x: "3351",
      y: "148",
    },
    width: "500",
    hitbox: {
      coordinates: {
        x: "50",
        y: "100",
      },
      width: "400",
      height: "250",
    },
    layer: 3,
    order: 24,
  },
  {
    name: "pirat",
    coordinates: {
      x: "3132",
      y: "548",
    },
    width: "750",
    hitbox: {
      coordinates: {
        x: "200",
        y: "300",
      },
      width: "350",
      height: "300",
    },
    layer: 3,
    order: 22,
  },
  {
    name: "pleteni",
    coordinates: {
      x: "2366",
      y: "876",
    },
    width: "300",
    hitbox: {
      coordinates: {
        x: "0",
        y: "0",
      },
      width: "300",
      height: "200",
    },
    layer: 3,
    order: 20,
  },
  {
    name: "prga",
    coordinates: {
      x: "2557",
      y: "697",
    },
    width: "400",
    hitbox: {
      coordinates: {
        x: "120",
        y: "50",
      },
      width: "200",
      height: "400",
    },
    layer: 5,
    order: 13,
  },
  {
    name: "princeznicka",
    coordinates: {
      x: "736",
      y: "509",
    },
    width: "760",
    hitbox: {
      coordinates: {
        x: "50",
        y: "100",
      },
      width: "300",
      height: "300",
    },
    layer: 5,
    order: 10,
  },
  {
    name: "rytir",
    coordinates: {
      x: "2650",
      y: "-100",
    },
    width: "600",
    hitbox: {
      coordinates: {
        x: "200",
        y: "750",
      },
      width: "300",
      height: "400",
    },
    layer: 3,
    order: 17,
  },
  {
    name: "venda",
    coordinates: {
      x: "1508",
      y: "-67",
    },
    width: "650",
    hitbox: {
      coordinates: {
        x: "150",
        y: "100",
      },
      width: "350",
      height: "350",
    },
    layer: 7,
    order: 6,
  },
  {
    name: "vrtulka",
    coordinates: {
      x: "309",
      y: "404",
    },
    width: "500",
    hitbox: {
      coordinates: {
        x: "100",
        y: "100",
      },
      width: "300",
      height: "300",
    },
    layer: 5,
    order: 12,
  },
  {
    name: "zajic",
    coordinates: {
      x: "447",
      y: "-8",
    },
    width: "700",
    hitbox: {
      coordinates: {
        x: "420",
        y: "40",
      },
      width: "200",
      height: "300",
    },
    layer: 3,
    order: 14,
  },
];
